import(/* webpackMode: "eager" */ "/tmp/8de795977415867/app/[locale]/error.tsx");
